<div class="draggable__list__header"></div>
<div
    class="draggable__list"
    cdkDropList
    [ngClass]="{ draggable__list__grab__cursor: isDragging, draggable__list__grabbing__cursor: isDragging }"
    (cdkDropListDropped)="onDrop($event)"
    [cdkDropListSortPredicate]="blockDragBasedOnCondition">
    <div
        *ngIf="showSelectAll"
        class="draggable__row">
        <div class="draggable__row__left__content">
            <sera-checkbox
                [(ngModel)]="selectAllRows"
                (stateChanged)="emitSelectOrUnselectedList()"
                [inputStyle]="inputStyle">
            </sera-checkbox>
            {{ 'PAGE.DROPDOWN_SELECT_ALL.LBL' | translate }}
        </div>
    </div>
    <div
        class="draggable__row"
        [ngClass]="{ draggable__list__grab__cursor: !isDragging, draggable__list__grabbing__cursor: isDragging }"
        *ngFor="let item of rowList; let i = index"
        cdkDrag
        (cdkDragStarted)="isDragging = true"
        (cdkDragEnded)="isDragging = false"
        [cdkDragDisabled]="!item.isDraggable">
        <div
            class="draggable__row__placeholder"
            *cdkDragPlaceholder></div>
        <div class="draggable__row__left__content">
            <sera-checkbox
                *ngIf="item.showCheckbox"
                [(ngModel)]="item.isChecked"
                (stateChanged)="emitUpdatedList()"
                [inputStyle]="inputStyle">
            </sera-checkbox>
            {{ item.displayText }}
        </div>
        <div
            *ngIf="item.isDraggable"
            class="draggable__row__right__content">
            <i class="ci ci-drag_indicator"></i>
        </div>
    </div>
</div>
